//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { Moment } from 'moment-timezone';

import { toastNotificationsActions } from '@legacy-components/common/toast-notifications/toastNotificationsActions';
import { ALTERNATE_TOASTS } from '@legacy-components/common/toast-notifications/toastNotificationsConstants';
import { ToastType } from '@legacy-components/common/toast-notifications/toastNotificationsModel';

/**
 * Toast notification helpers for the rescheduling workflow.
 */

export const addBatchReschedulingSuccessToast = (count: number) => {
  return toastNotificationsActions.addToastNotification({
    title: 'Rescheduled',
    type: ToastType.SUCCESS,
    message: `You have rescheduled ${count} posts.`,
    options: {
      toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
    },
  });
};

export const addBatchReschedulingGenericFailureToast = () => {
  return toastNotificationsActions.addToastNotification({
    title: 'Unable to Reschedule',
    type: ToastType.ERROR,
    message:
      'We are unable to reschedule your posts. Please try again or contact Bazaarvoice Support.',
    options: {
      toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
    },
  });
};

export const addReschedulingSuccessToast = (newTime: Moment) => {
  return toastNotificationsActions.addToastNotification({
    title: 'Rescheduled',
    type: ToastType.SUCCESS,
    message: `Your post was rescheduled to ${newTime.format(
      'LL',
    )} at ${newTime.format('LT')}.`,
    options: {
      toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
    },
  });
};

export const addTimeInPastFailureToast = () => {
  return toastNotificationsActions.addToastNotification({
    title: 'Unable to Reschedule',
    type: ToastType.ERROR,
    message:
      'We were unable to reschedule because the selected time was in the past. Please try again or contact Bazaarvoice Support.',
    options: {
      toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
    },
  });
};

export const addReschedulingFailureToast = () => {
  return toastNotificationsActions.addToastNotification({
    title: 'Unable to Reschedule',
    type: ToastType.ERROR,
    message:
      'We were unable to reschedule your post. Please try again or contact Bazaarvoice Support.',
    options: {
      toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
    },
  });
};
